import { EnergyLabelBadge as FableEnergyLabelBadge } from '@sainsburys-tech/fable'
import React from 'react'
import PropTypes from 'prop-types'
import { openAccordion } from '@/javascript/helpers/openAccordion'
import { pushEventAndTrack } from '@/javascript/helpers/taggingSerializer'

const onEnergyLabelClick = () => {
  openAccordion('#energy-rating')
  pushEventAndTrack({
    eventInfo: {
      eventName: 'pdp_energyRatingAnchor',
      eventInfo: 'energy rating information'
    }
  })
}

const EnergyLabelBadge = props => {
  return (
    <FableEnergyLabelBadge
      {...props}
      onClick={onEnergyLabelClick}
      className='energy-label-badge'
      id='energy-label-badge'
    />
  )
}

EnergyLabelBadge.propTypes = {
  ratingType: PropTypes.string,
  customLinkName: PropTypes.string,
  linkUrl: PropTypes.string,
  size: PropTypes.string
}

export default EnergyLabelBadge
